/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import profile from "assets/images/profile.png";
import DataTable from "examples/Tables/DataTable";
import { CircularProgress, Dialog, Icon, IconButton } from "@mui/material";
import applicator from "ajv/dist/vocabularies/applicator";
import colors from "assets/theme/base/colors";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { getAllApplicants } from "api";
import { useEffect, useRef, useState } from "react";
import debounce from "lodash.debounce";
import CloseIcon from "@mui/icons-material/Close";

export default function data({ job, isMyProfile = true }) {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [skip, setSkip] = useState();
  const limit = 10000;
  const [search, setSearch] = useState();
  const [loading, setLoading] = useState(false);

  const [pdfUrl, setPdfUrl] = useState(null);
  const [openPreview, setOpenPreview] = useState(false);

  useEffect(() => {
    setSkip(0);
  }, []);

  useEffect(() => {
    if (skip === 0) {
      getAllApplicantsApi();
    } else {
      setSkip(0);
    }
  }, [search]);

  useEffect(() => {
    if (skip !== undefined) {
      getAllApplicantsApi();
    }
  }, [skip]);

  const debouncedFetch = useRef(
    debounce((searchVal) => {
      setSearch(searchVal);
    }, 500)
  ).current;

  const getAllApplicantsApi = () => {
    var params = {
      skip: skip,
      limit: limit,
      id: job?._id,
      name: search,
    };
    setLoading(true);
    getAllApplicants({
      params: params,
    })
      .then((responseJson) => {
        if (skip === 0) {
          setList(responseJson?.jobs);
        } else {
          setList([...list, ...responseJson?.jobs]);
        }
      })
      .catch((e) => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const Applicant = ({ name, image, totalExperience }) => {
    const imgWidth = image ? "100%" : "50%";
    const imgHeight = image ? "100%" : "50%";
    const imgResize = image ? "cover" : "contain";

    return (
      <MDBox display="flex" gap={2}>
        <MDAvatar
          src={image || profile}
          size="sm"
          sx={{
            width: "45px", // optional: control size
            height: "45px", // optional: control size
            border: "2px solid",
            borderColor: "success.main",
            "& img": {
              width: imgWidth,
              height: imgHeight,
              objectFit: imgResize,
              objectPosition: "center",
            },
          }}
        />
        <MDBox>
          <MDTypography
            display="block"
            variant="button"
            fontWeight="medium"
            noWrap
            sx={{
              maxWidth: "300px",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {name}
          </MDTypography>

          <MDTypography variant="caption">{totalExperience}</MDTypography>
          {/* <MDBox>
          <MDTypography variant="caption">
            {
              "Wireframing, Information architecture, Interaction design, User research, Visual communication, Usability testing, Design software"
            }
          </MDTypography>
        </MDBox> */}
        </MDBox>
      </MDBox>
    );
  };

  const columns = () => {
    return [
      { Header: "name", accessor: "name", align: "left" },
      { Header: "contact details", accessor: "contact", align: "left" },
      { Header: "applied on", accessor: "applied", align: "center" },

      { Header: "resume", accessor: "resume", align: "center" },
      {
        Header: "action",
        accessor: "action",
        align: "center",
      },
    ];
  };

  const rows = () => {
    var rowsData = [];

    list.map((item) =>
      rowsData.push({
        name: (
          <Applicant
            name={`${item?.applyBy?.firstName || ""} ${item?.applyBy?.lastName || ""}`}
            image={item?.applyBy?.profileURL}
            totalExperience={item?.totalExperience}
          />
        ),
        contact: (
          <MDBox sx={{ px: 1 }}>
            <MDTypography display="block" variant="caption">
              {`${item?.applyBy?.code} ${item?.applyBy?.phone}`}
            </MDTypography>
            <MDTypography variant="caption">{item?.applyBy?.email}</MDTypography>
          </MDBox>
        ),
        applied: (
          <MDBox sx={{ px: 1 }}>
            <MDTypography variant="caption" noWrap>{`${moment(item?.createdAt).format(
              "DD MMM YYYY"
            )}`}</MDTypography>
          </MDBox>
        ),
        resume: (
          <MDBox onClick={() => handleResume(item?.applyBy)} sx={{ px: 1 }}>
            {item?.applyBy?.documentURL && (
              <MDTypography
                component="a"
                variant="caption"
                color="secondary"
                fontWeight="medium"
                sx={{ cursor: "pointer" }}
              >
                <Icon fontSize="small">article_outlined</Icon>
              </MDTypography>
            )}
          </MDBox>
        ),
        action: (
          <MDBox onClick={() => handleProfile(item?.applyBy)} sx={{ px: 1 }}>
            <MDTypography
              component="a"
              variant="caption"
              color="secondary"
              fontWeight="medium"
              sx={{ cursor: "pointer" }}
            >
              <Icon fontSize="small">arrow_forward</Icon>
            </MDTypography>
          </MDBox>
        ),
      })
    );

    return rowsData;
  };

  const onSearchData = (val) => {
    debouncedFetch(val);
  };

  const handleProfile = (item) => {
    navigate("/profile/profile-detail", { state: { user: item } });
  };

  const handleResume = (item) => {
    if (item?.documentURL) {
      setPdfUrl(item?.documentURL);
      setOpenPreview(true);
    }
  };

  const pdfViewer = () => {
    return (
      <Dialog open={openPreview} onClose={() => setOpenPreview(false)} fullWidth maxWidth="lg">
        <MDBox p={2} display="flex" justifyContent="space-between" alignItems="center">
          <MDTypography variant="h6">PDF Preview</MDTypography>
          <IconButton onClick={() => setOpenPreview(false)}>
            <CloseIcon />
          </IconButton>
        </MDBox>
        <iframe
          src={`https://docs.google.com/gview?url=${encodeURIComponent(pdfUrl)}&embedded=true`}
          style={{ width: "100%", height: "80vh", border: "none" }}
          title="PDF Viewer"
        />
      </Dialog>
    );
  };

  return (
    <MDBox sx={{ width: "100%", overflowX: "auto" }}>
      <DataTable
        table={{ columns: columns(), rows: rows() }}
        isSorted={false}
        entriesPerPage={false}
        showTotalEntries={false}
        canSearch={true}
        noEndBorder
        onSearch={(val) => {
          onSearchData(val);
        }}
      />
      {loading && (
        <MDBox display="flex" justifyContent="center" mt={2}>
          <CircularProgress size={24} color="success" />
        </MDBox>
      )}

      {pdfViewer()}
    </MDBox>
  );
}
